import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <div className="container">
        <section className="hero">
          <h2 className="hero-title">Bienvenue chez Maia&Ostara</h2>
          <p className="hero-subtitle">
            Des créations uniques pour femmes, faites à la main avec amour
          </p>
        </section>

        <section className="values">
          <div className="value-card">
            <div className="value-icon">✨</div>
            <h3>Vêtements Uniques</h3>
            <p>
              Chaque pièce est unique, créée avec soin pour vous offrir un vêtement 
              qui vous ressemble et que personne d'autre ne portera.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">🇫🇷</div>
            <h3>Fait à la Main en France</h3>
            <p>
              Toutes nos créations sont confectionnées artisanalement en France, 
              dans le respect des savoir-faire traditionnels.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">♻️</div>
            <h3>Tissus Recyclés</h3>
            <p>
              Nous donnons une seconde vie aux tissus en les "upcyclant", 
              pour une mode plus responsable et respectueuse de l'environnement.
            </p>
          </div>
        </section>

        <section className="gallery">
          <h2 className="section-title">Nos Créations Fleuries</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <div className="placeholder-image floral-1">
                <span>🌸</span>
                <p>Robe fleurie printemps</p>
              </div>
            </div>
            <div className="gallery-item">
              <div className="placeholder-image floral-2">
                <span>🌺</span>
                <p>Jupe à motifs floraux</p>
              </div>
            </div>
            <div className="gallery-item">
              <div className="placeholder-image floral-3">
                <span>🌼</span>
                <p>Haut fleuri été</p>
              </div>
            </div>
            <div className="gallery-item">
              <div className="placeholder-image floral-4">
                <span>🌻</span>
                <p>Robe champêtre</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
